export default __webpack_public_path__ + "static/media/_IMG5933.5942f3a9.jpg";